import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {AddAuditRecordDialogComponent} from '@features/audit-tracker/components/add-audit-record-dialog/add-audit-record-dialog.component';
import {StartWorkflowDialogComponent} from '@features/audit-tracker/components/start-workflow-dialog/start-workflow-dialog.component';
import {AuditCaseArchiveDialogComponent} from '@features/audit-tracker/components/audit-case-archive-dialog/audit-case-archive-dialog.component';
import {ReviewWorkflowDialogComponent} from '@features/audit-tracker/components/review-workflow-dialog/review-workflow-dialog.component';
import {EntityCellViewerComponent} from '@features/audit-tracker/components/cell-editor/entity-cell-viewer/entity-cell-viewer.component';
import {AddAuditStageRecordDialogComponent} from '@features/audit-tracker/components/add-audit-stage-record-dialog/add-audit-stage-record-dialog.component';
import {StateSelectorCellEditorComponent} from '@features/audit-tracker/components/cell-editor/state-selector-cell-editor/state-selector-cell-editor.component';
import {TaskAssignedToCellViewerComponent} from '@features/audit-tracker/components/cell-editor/task-assigned-to-cell-viewer/task-assigned-to-cell-viewer.component';
import {AddAuditStageDialogComponent} from '@features/audit-tracker/components/add-audit-stage-dialog/add-audit-stage-dialog.component';
import {ResponseDaysAvailableCellViewerComponent} from "@features/audit-tracker/components/cell-editor/response-days-available-cell-viewer/response-days-available-cell-viewer.component";

// @dynamic
export class AuditTrackerDynamicComponentHelper {
  public static components: any;

  public static init() {
    if (AuditTrackerDynamicComponentHelper.components) {
      return;
    }
    const components = {};

    components['AddAuditRecordDialogComponent'] = AddAuditRecordDialogComponent;
    components['StartWorkflowDialogComponent'] = StartWorkflowDialogComponent;
    components['AuditCaseArchiveDialogComponent'] = AuditCaseArchiveDialogComponent;
    components['ReviewWorkflowDialogComponent'] = ReviewWorkflowDialogComponent;
    components['EntityCellViewerComponent'] = EntityCellViewerComponent;
    components['AddAuditStageRecordDialogComponent'] = AddAuditStageRecordDialogComponent;
    components['StateSelectorCellEditorComponent'] = StateSelectorCellEditorComponent;
    components['TaskAssignedToCellViewerComponent'] = TaskAssignedToCellViewerComponent;
    components['AddAuditStageDialogComponent'] = AddAuditStageDialogComponent;
    components['ResponseDaysAvailableCellViewer'] = ResponseDaysAvailableCellViewerComponent;

    AuditTrackerDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    AuditTrackerDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }

  public static getComponentArray(): any[] {
    AuditTrackerDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(AuditTrackerDynamicComponentHelper.components).forEach(key => {
      componentArray.push(AuditTrackerDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
